.footer {
  background: var(--comp-footer-color);
  color: var(--theme-white);
  min-height: 50px;
  padding: 25px 0;
  position: relative;
}

.content {
  align-items: center;
  display: flex;
  justify-content: space-around;
  margin: auto;
  max-width: 1200px;
  width: 95%;
}

.logo {
  align-items: center;
  color: var(--theme-white);
  display: flex;
  flex-direction: column;
  height: 100px;
  margin-left: 8px;
}

.logo svg {
  height: 100px;
  width: 150px;
}

.logo a,
.logo a:visited,
.logo a:hover {
  color: var(--theme-white);
}

.logoTitle {
  font-size: var(--font-size-6);
  line-height: var(--line-size-6);
}

.text {
  font-size: 0.8rem;
  padding: 0 1rem;
}

.text p {
  margin: 0.5rem 0;
}

.externalIcons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 350px;
}

.externalIcons>* {
  color: var(--theme-white);
  font-size: 1.5rem;
  padding: 5px 0;
  text-align: center;
  transition: opacity 0.2s ease-in;
  width: 14%;
}

.externalIcons>*:hover {
  opacity: 0.7;
}

.break {
  flex-basis: 100%;
  height: 0;
}



.team,
.team:hover,
.team:visited,
.link,
.link:hover,
.link:visited {
  color: #fff;
  text-decoration: none;
  transition: opacity 0.2s ease-in;
}

.link:hover {
  opacity: 0.7;
}

.linkContainer {
  display: flex;
  flex-flow: row wrap;
  gap: 8px
}

.build {
  bottom: 0;
  color: rgb(0 0 0 / 30%);
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  margin-right: 10px;
  padding: 10px;
  pointer-events: none;
  position: absolute;
  right: 0;
  user-select: none;
}

@media screen and (width <=1050px) {
  .logo {
    display: none;
  }
}

@media screen and (width <=800px) {
  /* We add a margin because of the bottom position of the header */
  .footer {
    margin-bottom: 60px;
  }

  .content {
    flex-direction: column-reverse;
  }

  .externalIcons {
    justify-content: center;
    margin: 0;
    margin-bottom: 25px;
    max-width: 320px;
    width: 100%;
  }
}